export function removeDiacritics(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function getRightSubstring(str, qtdChars) {
    return str.slice(str.length - qtdChars, str.length);
}

export function getLeftSubstring(str, qtdChars) {
    return str.slice(0, qtdChars - str.length);
}

export function truncate(text: string, length: number) {
    if (text && text.length > length) {
        return text.slice(0, length) + '...';
    } else {
        return text;
    }
}

export function padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr(size * -1, size);
}

export function clearNumber(value: string): string {
    return value ? value.replace(/\D+/g, '') : '';
}

export function removerZerosAEsquerda(valor): string {
    return valor.replace(/^0+/, '');
}

export function integerToTime(input: number, digits?: string, nullable?: boolean): string {
    let horas: string;
    let minutos: string;
    const qtdeDigitosDeHora = digits === undefined ? 2 : parseInt(digits);

    if (input) {
        horas = ((input - (input % 60)) / 60).toString();
        minutos = (input % 60).toString();

        for (var i = horas.length; i < qtdeDigitosDeHora; i++) {
            horas = '0' + horas;
        }
        if (minutos.length == 1) minutos = '0' + minutos;

        return horas + ':' + minutos;
    } else {
        if (nullable && (input === null || input === undefined)) {
            return '';
        }
        horas = '0';

        for (var i = horas.length; i < qtdeDigitosDeHora; i++) {
            horas = '0' + horas;
        }

        return horas + ':00';
    }
}

export function formatarValorDecimal(valor: number, casasDecimais?: number): string {
    if (!valor) {
        return '';
    }
    if (!casasDecimais) {
        casasDecimais = 2;
    }
    return valor.toFixed(casasDecimais).replace('.', ',');
}

export function formatarMensagem(template: string, parametros: Record<string, string>): string {
    return Object.entries(parametros).reduce((mensagem, [chave, valor]) => mensagem.replace(`{${chave}}`, valor), template);
}

export function generateUID() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
